import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

export default function Banner() {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const imgUrl = process.env.PUBLIC_URL + '/images/banner-food.webp';

  const handleCreateRecipe = () => {
    if (user) {
      navigate('/recipes/create');
    } else {
      navigate('/login');
    }
  };
  return (
    <div className="relative min-h-screen bg-black text-white overflow-hidden w-screen">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={imgUrl}
          alt="Delicious food"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 text-center">
        <div className="max-w-4xl">
          {/* Main Heading */}
          <h1 className="text-6xl md:text-8xl font-bold mb-8 tracking-tight">
            Bold flavors,
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
              simple recipes.
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto font-light">
            Discover, cook, and share dishes that excite your taste buds.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={handleCreateRecipe}
              className="px-8 py-4 text-lg font-semibold text-white transition-all hover:scale-105 hover:shadow-2xl hover:shadow-pink-500/50"
              style={{ backgroundColor: '#DB025F' }}>
              Create Recipe
            </button>
            <button 
              onClick={() => navigate('/search')}
              className="px-8 py-4 text-lg font-semibold text-white border-2 border-white hover:bg-white hover:text-black transition-all hover:scale-105">
              Browse Recipes
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <svg className="w-6 h-6 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </div>
  );
}

